import React, { useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import PreviewNavbar from "./PreviewNavbar";
import { SocialLinks, CONTACT } from "./SocialLinks";

const PreviewFooter = () => (
  <footer className="border-t border-black/[0.06] bg-[#F5F4F0]" data-testid="preview-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <Link to="/" className="font-display text-2xl font-semibold text-[#111827]">
            Stine Eskesen
          </Link>
        </div>

        <div>
          <p className="eyebrow mb-4 text-[11px] font-semibold text-[#111827]/40">Kontakt</p>
          <ul className="space-y-2 text-[15px] text-[#111827]/70">
            {CONTACT.emails.map((mail) => (
              <li key={mail}>
                <a href={`mailto:${mail}`} className="transition-colors hover:text-[#852936]">
                  {mail}
                </a>
              </li>
            ))}
            <li>
              <a href={CONTACT.phoneHref} className="transition-colors hover:text-[#852936]">
                {CONTACT.phone}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4 text-[11px] font-semibold text-[#111827]/40">Følg med</p>
          <SocialLinks />
        </div>
      </div>

      <div className="mt-12 border-t border-black/[0.06] pt-6 text-sm text-[#111827]/50">
        © {new Date().getFullYear()} Stine Eskesen · Coaching &amp; Undervisning
      </div>
    </div>
  </footer>
);

const PreviewLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="preview-root min-h-screen" data-testid="preview-root">
      <PreviewNavbar />
      <main className="pt-[72px]">
        <Outlet />
      </main>
      <PreviewFooter />
    </div>
  );
};

export default PreviewLayout;
